import { Navigate } from 'react-router';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';
import {
  defaultTransportTabPath,
  getAvailableTransportTabs,
  transportTabPathname,
  type TransportTabAvailability,
} from 'src/pages/company-transactions/transport/tabs';

type Props = {
  availability: TransportTabAvailability;
};

export const TransportTabs = ({ availability }: Props) => {
  return (
    <Tabs data-testid="transport-transactions-tabs">
      {getAvailableTransportTabs(availability).map((tab) => (
        <Link
          key={tab.path}
          to={transportTabPathname(tab.path)}
          data-testid={`transport-tab-${tab.path}`}
        >
          {tab.label}
        </Link>
      ))}
    </Tabs>
  );
};

export const TransportRedirect = () => (
  <Navigate replace to={transportTabPathname(defaultTransportTabPath)} />
);
